"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Queue = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// A standard FIFO queue implementation
class Queue {
  constructor() {
    this._queue = [];
  }
  get length() {
    return this._queue.length;
  }
  get isEmpty() {
    return this._queue.length === 0;
  }
  enqueue(item) {
    this._queue.push(item);
  }
  dequeue() {
    return this._queue.shift();
  }
  process(callback) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      while (!_this.isEmpty) {
        const item = _this.dequeue();
        yield callback(item);
      }
    })();
  }
}
exports.Queue = Queue;